<form [formGroup]="formGroup">
  <div class="d-flex flex-column">
    <div class="field-container">
      <h3> {{'createUser.contactInformationForm.title'|translate}}</h3>
      <h5> {{'createUser.contactInformationForm.subtitle'|translate}}</h5>
    </div>
    <app-input-field [control]="formGroup.controls.telephoneNumber" class="field-container"
                     [label]="'createUser.contactInformationForm.phoneNumber'|translate">
      <input name="telephoneNumber" formControlName="telephoneNumber" class="input">
    </app-input-field>
    <app-input-field [control]="formGroup.controls.mobileNumber" class="field-container"
                     [label]="'createUser.contactInformationForm.mobileNumber'|translate">
      <input name="mobileNumber" formControlName="mobileNumber" class="input">
    </app-input-field>

    <div class="d-flex justify-content-between field-container">
      <app-input-field [control]="formGroup.controls.street" class="bigger-input"
                       [label]="'createUser.contactInformationForm.street'|translate">
        <input name="street"
               formControlName="street"
               class="input">
      </app-input-field>

      <app-input-field [control]="formGroup.controls.houseNumber" class="smaller-input"
                       [label]="'createUser.contactInformationForm.houseNumber'|translate">
        <input name="houseNumber"
               formControlName="houseNumber"
               class="input"
               value="4">
      </app-input-field>
    </div>

    <div class="d-flex justify-content-between field-container">
      <app-input-field [control]="formGroup.controls.postalCode" class="smaller-input"
                       [label]="'createUser.contactInformationForm.postalCode'|translate">
        <input name="postalCode"
               formControlName="postalCode"
               type="text"
               class="input">
      </app-input-field>

      <app-input-field [control]="formGroup.controls.location" class="bigger-input"
                       [label]="'createUser.contactInformationForm.location'|translate">
        <input name="location"
               formControlName="location"
               class="input">
      </app-input-field>
    </div>
  </div>
</form>
